import React from 'react';
import IllustrationPhoneApp from '../../icons/IllustrationPhoneApp';
import IllustratedLockedIcon from '../../icons/IllustratedLockedIcon';
import IllustratedUnlockedIcon from '../../icons/IllustratedUnlockedIcon';
import PhoneWithPickupPINIcon from '../../icons/PhoneWithPickupPINIcon';
import styles from './DetailsSection.module.css';

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {React.ReactElement} props.icon
 * @param {string} props.subtitle
 * @param {string} props.title
 */
function DetailItem({ className = '', icon, subtitle, title }) {
  return (
    <div className={`${styles.detailItem} ${className}`}>
      {React.cloneElement(icon, { className: styles.detailItemIcon })}
      <div>
        <h3 className={styles.detailItemTitle}>{title}</h3>
        <h4 className={styles.detailItemSubtitle}>{subtitle}</h4>
      </div>
    </div>
  );
}

/**
 * @param {object} props
 * @param {FF.Location__LDP} props.locationData
 */
export default function DetailsSection({ locationData }) {
  if (locationData.type !== 'FRIDGE') {
    return null;
  }

  const hasMobileOrdering = locationData.locationConfigs.reserve === 1;
  const isPrivate = locationData.locationConfigs.accessTo === 'Private';

  return (
    <section className={styles.wrapper}>
      <h2 className={styles.header}>Fridge Details</h2>
      <div className={hasMobileOrdering ? styles.details : styles.singleDetail}>
        {hasMobileOrdering && (
          <DetailItem
            className={styles.mobileOrderingDetail}
            icon={<IllustrationPhoneApp />}
            title="Mobile Ordering"
            subtitle="Order your items ahead for pickup at this Fridge."
          />
        )}
        <DetailItem
          className={styles.fridgeAccessDetail}
          {...(isPrivate
            ? {
                title: 'Private Fridge',
                subtitle: 'Open to those with building access.',
                icon: <IllustratedLockedIcon />,
              }
            : {
                title: 'Public Fridge',
                subtitle: 'Open to everyone.',
                icon: <IllustratedUnlockedIcon />,
              })}
        />
        {hasMobileOrdering && (
          <DetailItem
            className={styles.touchlessPickupDetail}
            icon={<PhoneWithPickupPINIcon />}
            title="Pick Up PIN"
            subtitle="Order ahead on the app and pick up your food via Pick Up PIN."
          />
        )}
      </div>
    </section>
  );
}
